import groupStores  from './groupStores';
import snackbar  from './snackbar'
import notifications from './notifications'


export default {
  snackbar,
  groupStores,
  notifications,
}